<template>
  <div class="page page__list">
    <div class="filter-bar" @click="select">
      <span>
        年月 {{ ym }}
        <i class="caret"></i>
      </span>
    </div>

    <div class="page__bd" v-if="form">
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">工资构成</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_basewage">
            <label class="weui-form-preview__label">基本工资</label>
            <span class="weui-form-preview__value">
              {{ numberFormat(form.wd_basewage,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_postwage">
            <label class="weui-form-preview__label">岗位工资</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_postwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_meritwage">
            <label class="weui-form-preview__label">绩效工资</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.wd_meritwage,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_piecewage">
            <label class="weui-form-preview__label">计件工资</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_piecewage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_senioritywage">
            <label class="weui-form-preview__label">工龄工资</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_senioritywage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_subsidy">
            <label class="weui-form-preview__label">补助</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_subsidy,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_otherwage">
            <label class="weui-form-preview__label">其他</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_otherwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_reissue">
            <label class="weui-form-preview__label">补发</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_reissue,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_wage">
            <label class="weui-form-preview__label">合计</label>
            <span
              class="weui-form-preview__value"
              >{{ numberFormat(form.wd_wage,'#,##0.00') }}
            </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.wd_quanqinwage || form.wd_overtimepay || form.wd_late || form.wd_absenteeism || form.wd_leaveearly || form.wd_personalleave || form.wd_sickleave || form.wd_attendancecut || form.wd_othercut">
        <div class="weui-panel__hd">考勤</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_quanqinwage">
            <label class="weui-form-preview__label">全勤奖金</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_quanqinwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_overtimepay">
            <label class="weui-form-preview__label">加班费</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_overtimepay,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_late">
            <label class="weui-form-preview__label">迟到</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_late,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_absenteeism">
            <label class="weui-form-preview__label">旷工</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_absenteeism,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_leaveearly">
            <label class="weui-form-preview__label">早退</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_leaveearly,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_personalleave">
            <label class="weui-form-preview__label">事假</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_personalleave,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_sickleave">
            <label class="weui-form-preview__label">病假</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_sickleave,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_attendancecut">
            <label class="weui-form-preview__label">考勤扣款</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_attendancecut,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_othercut">
            <label class="weui-form-preview__label">其他扣款</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_othercut,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.wd_commission || form.wd_reward || form.wd_otheryf">
        <div class="weui-panel__hd">其他应发</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_commission">
            <label class="weui-form-preview__label">业绩提成</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_commission,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_reward">
            <label class="weui-form-preview__label">奖励</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_reward,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_otheryf">
            <label class="weui-form-preview__label">其他应发</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_otheryf,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.wd_amercement || form.wd_otheryk">
        <div class="weui-panel__hd">其他应扣</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_amercement">
            <label class="weui-form-preview__label">罚款</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_amercement,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_otheryk">
            <label class="weui-form-preview__label">其他应扣</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_otheryk,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应发金额</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_yfwage,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.wd_btcanbuwage || form.wd_btjiaotongwage || form.wd_btgaowenwage || form.wd_btzhufangwage || form.wd_btqitawage">
        <div class="weui-panel__hd">补贴</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_btcanbuwage">
            <label class="weui-form-preview__label">餐补</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_btcanbuwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_btjiaotongwage">
            <label class="weui-form-preview__label">交通补贴</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_btjiaotongwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_btgaowenwage">
            <label class="weui-form-preview__label">高温补贴</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_btgaowenwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_btzhufangwage">
            <label class="weui-form-preview__label">住房补贴</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_btzhufangwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_btqitawage">
            <label class="weui-form-preview__label">其他补贴</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_btqitawage,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.wd_shebao || form.wd_gongjijin || form.wd_nianjin || form.wd_geshui || form.wd_qita">
        <div class="weui-panel__hd">代扣</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.wd_shebao">
            <label class="weui-form-preview__label">社保(个人)</label>
            <span class="weui-form-preview__value">
              {{ numberFormat(form.wd_shebao,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_gongjijin">
            <label class="weui-form-preview__label">公积金(个人)</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.wd_gongjijin,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_nianjin">
            <label class="weui-form-preview__label">年金(个人)</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_nianjin,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_geshui">
            <label class="weui-form-preview__label">个税</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_geshui,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.wd_qita">
            <label class="weui-form-preview__label">其他</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_qita,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">实发金额</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.wd_actwage,'#,##0.00') }}
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      ym: null,
      form: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.ym = to.params.ym
      vm.search();
    });
  },
  methods: {
    search() {
      var me = this
      me.$loading({
        url: "/api/hr/wage/getMyWage/" + me.ym,
      }).then(function (res) {
        if (res.success) {
          me.form = res.data
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    select() {
      var me = this,
        year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        years = [],
        months = [
          {value: '01', label: '1月'}, 
          {value: '02', label: '2月'},
          {value: '03', label: '3月'},
          {value: '04', label: '4月'},
          {value: '05', label: '5月'},
          {value: '06', label: '6月'},
          {value: '07', label: '7月'},
          {value: '08', label: '8月'},
          {value: '09', label: '9月'},
          {value: '10', label: '10月'},
          {value: '11', label: '11月'},
          {value: '12', label: '12月'},
        ]
      for (let i = year - 20, len = year; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        months,
        {
          title: "选择年月",
          defaultValue: [year, month],
          onConfirm: function (r) {
            me.ym = r[0].value + r[1].value
            me.search()
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
</style>